exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".testblue {\n     color: blue;\n }", ""]);

// exports
